var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{staticClass:"nice-logo"},[_c('img',{style:(_vm.logoStyle),attrs:{"src":require("@/assets/logo/nice-basic.png"),"alt":"nice logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }